import React from "react";

import { Icon, IconSizeEnum } from "@/components/common/icon";

import { CircleIconColorEnum, CircleIconProps } from "./types";
import "./styles.scss";

const CircleIcon = (props: CircleIconProps) => {
  const { type, color } = props;

  return (
    <div className={`circle-icon ${color.toLowerCase()}`}>
      <Icon type={type} size={IconSizeEnum.Size28} />
    </div>
  );
};

export { CircleIcon, CircleIconColorEnum };
